/* The icon font has no power mark, so it is drawn here, the way the tab strip draws its eye. */
export const PowerIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 16 16" aria-hidden="true">
    <path d="M8 1.8v5.4M4.4 4a5.2 5.2 0 1 0 7.2 0" />
  </svg>
)
